(function () {

    'use strict';

    if (typeof window === 'undefined') {

        const _ = require('lodash');
        _.extend(module.exports, exports(
            require('./metric.js'),
            require('../../enums/metrics.js'),
            require('../../enums/timePeriod.js'),
            require('../../../lib/riq-moment.js'),
            require('lodash')
        ));

    } else {
        RivalIQ.metric.timePeriod = exports(
            RivalIQ.metric,
            RivalIQ.enums,
            RivalIQ.enums.timePeriod,
            window.moment,
            window._
        );
    }

    function exports(metricFn, metricEnums, timePeriodEnums, moment, _) {

        function isMainPeriod(metric, data) {
            return metricFn.dimensionValue(metric, 'timeAnalysisMode', data) === metricEnums.timeAnalysisMode.MAIN_PERIOD;
        }

        function isNotRelative(metric, data) {
            const tam = metricFn.dimensionValue(metric, 'timeAnalysisMode', data);

            return tam === metricEnums.timeAnalysisMode.MAIN_PERIOD ||
                tam === metricEnums.timeAnalysisMode.COMPARE_PERIOD;
        }


        function isByWeek(metric) {
            return _.includes(metric.dimensions, 'week');
        }

        function isByMonth(metric) {
            return _.includes(metric.dimensions, 'month');
        }

        function dropInterval(metric) {
            const dimensions = _.without.apply(null, [metric.dimensions].concat(_.values(timePeriodEnums.interval)));
            return _.create(metric, {
                dimensions: dimensions
            });
        }

        function hasInterval(metric) {
            return Boolean(getInterval(metric));
        }

        function getInterval(metric) {
            return _.intersection(metric.dimensions, ['day', 'week', 'month'])[0];
        }

        function setInterval(metric, interval) {
            metric = dropInterval(metric);
            metric.dimensions.unshift(interval);

            return metric;
        }

        // DEPRECATED new metrics should specify interval via their dimensions
        function getPeriod(metric) {
            return timePeriodEnums.interval[metric.interval || timePeriodEnums.period.day];
        }

        // NOTE this is temporary for legacy metrics. The metric timeperiod
        // should always be stored in timePeriod
        function getDataTimePeriod(metric) {
            if (metric.startDate) {
                return {
                    mainPeriodStart: moment.utc(metric.startDate).startOf('day'),
                    mainPeriodEnd: moment.utc(metric.endDate).endOf('day')
                };
            }

            if (!metric.timePeriod) {
                // NOTE this will blow up on the server, and rightfully so
                return RivalIQ.state.view.get('timePeriod');
            }

            return metric.timePeriod;
        }


        function getDefaultInterval(timePeriod) {

            if (!timePeriod) {
                return 'week';
            }
            const completeWeeksEnd = moment.utc(timePeriod.mainPeriodEnd).add(1, 'day').startOf('week');
            const completeWeeksStart = moment.utc(timePeriod.mainPeriodStart).subtract(1, 'day').endOf('week');
            const numCompleteWeeks = completeWeeksEnd.diff(completeWeeksStart, 'weeks');
            if (numCompleteWeeks < 6) {
                return 'day';
            }

            const completeMonthsEnd = moment.utc(timePeriod.mainPeriodEnd).add(1, 'day').startOf('month');
            const completeMonthsStart = moment.utc(timePeriod.mainPeriodStart).subtract(1, 'day').endOf('month');
            const numCompleteMonths = completeMonthsEnd.diff(completeMonthsStart, 'months');
            if (numCompleteMonths >= 6) {
                return 'month';
            }

            return 'week';
        }

        return {
            isByWeek: isByWeek,
            isByMonth: isByMonth,
            isMainPeriod: isMainPeriod,
            isNotRelative: isNotRelative,
            setInterval: setInterval,
            getInterval: getInterval,
            hasInterval: hasInterval,
            getPeriod: getPeriod,
            getDataTimePeriod: getDataTimePeriod,
            getDefaultInterval: getDefaultInterval
        };
    }
})();
